module.exports = __webpack_public_path__ + "img/bb_g3_snout.87e5f94b.svg";